// connected-user.service.ts
import { Injectable } from '@angular/core';
import { UserStore } from 'app/core/user/user.types';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { ConnectedUserService } from '../../../../core/user/connected-user.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private mockUser: UserStore = {
    id: '12345',
    email: 'mehdi.mahmoudi@aceenergie.com',
    fullname: 'John Doe',
    role: 'Admin',
    status: 'Active',
    tenantId: 'tenant-67890',
    tenant: 'Example Tenant',
    firstname: 'John',
    lastname: 'Doe',
    enabled: true,
    isOnboarded: true,
    audience: 'exampleAudience',
    avatar: 'https://via.placeholder.com/150'
  };

  constructor(private readonly _connectedUserService: ConnectedUserService) {}

  // Simulate an API call to fetch the connected user with a delay
  getConnectedUser(): Observable<UserStore> {
    return this._connectedUserService.getUserByEmail(this.mockUser.email).pipe(delay(1000));
    //return of(this.mockUser).pipe(delay(1000)); // Delay to mimic HTTP request
  }
}
